import { render, staticRenderFns } from "./PatientFormular.vue?vue&type=template&id=6ee9fea4&scoped=true"
import script from "./PatientFormular.vue?vue&type=script&lang=js"
export * from "./PatientFormular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee9fea4",
  null
  
)

export default component.exports